import {  EVENT_ID, ADD_USER_DETAILS, LANGUAGE_TEXT_LIVE, LOADING_FAILED, LOADING_SUCCESS, SET_LANGUAGE_TEXT, SET_SUBMIT_FORM, CLEAR_USER_DETAILS } from "../constants/s2txtContants";


export const loadingStatusReducer = (state ={status: true}, action) => {

    switch(action.type) {
        case LOADING_FAILED:
            return {
               status: action.payload
            };
        case LOADING_SUCCESS:
            return {
                status: action.payload
            };
        default: 
            return state
    }
}

export const languageTextDetails = (state ={language: 'English', live: false}, action) => {
    switch (action.type) {
        case LANGUAGE_TEXT_LIVE:
            return {
                ...state,
                live: action.payload.live,
                langCode: action.payload.langCode
            } 
        case SET_LANGUAGE_TEXT:
            return {
                language: action.payload,
                live: false
            }   
        default:
            return state
    }
}

export const eventDetailsReducer = (state = {id: ''}, action) => {
    switch (action.type) {
        case EVENT_ID:
            return {
                id: action.payload
            }
        default:
            return state
    }
}

export const streamAttendanceReportReducer = (state = {submitState: false, userDetails: []}, action) => {
    switch (action.type) {
        case SET_SUBMIT_FORM:
            return {
                ...state,
                submitState: action.payload
            }
        case ADD_USER_DETAILS:
            return {
                ...state,
                userDetails: [
                    ...state.userDetails,
                    action.payload
                ]
            }
        case CLEAR_USER_DETAILS:
            return {
                ...state,
                userDetails: []
            }
        default:
            return state
    }
}